<div class="editor">
    <!-- Hiển thị tiêu đề mở rộng -->
    <div class="editor-header" *ngIf="isViewAll">
        <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
        <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
    </div>
    <ng-container *ngIf="!isViewAll">
        <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
            <!-- HIỂN THỊ -->
            <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
                <!-- Lựa chọn hiển thị cho các thiết bị/Quản lý ở admin -->
                <div class="editor-field">
                    <!-- Lựa chọn hiển thị cho các thiết bị -->
                    <app-hide-show-config
                        [device]="device"
                        [elementChoosing]="objectChoosing">
                    </app-hide-show-config>
                </div>
            </li>
             
            <!-- TIÊU ĐỀ CƠ BẢN -->
            <li nz-submenu nzTitle="{{'tieu_de_co_ban' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
                <div class="editor-field">
                    <div class="editor-field-body">
                        <div class="title-collapse">
                            <div class="show-dynamic">
                                <!-- Thêm nội dung -->
                                <div class="field-row">
                                    <div class="config-name mt-2">
                                        <p>{{ 'them_noi_dung' | translate }}</p>
                                        <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                                            [(ngModel)]="staticdata.total_collapse"
                                            (ngModelChange)="updateCollapse($event)">
                                        </nz-input-number>
                                    </div>
                                </div>
                                <!-- Khoảng cách các nội dung -->
                                <div class="field-row">
                                    <div class="config-name mt-2">
                                        <p>{{ 'khoang_cach_cac_noi_dung' | translate }}</p>
                                        <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                                            [ngModel]="class['text-collapse__body']['margin-bottom'] | vhnumber"
                                            (ngModelChange)="class['text-collapse__body']['margin-bottom'] = $event +'px'"
                                            (nzBlur)="updateClass()">
                                        </nz-input-number>
                                    </div>
                                </div>
                                <!-- Nội dung chữ -->
                                <div class="field-row">
                                    <mat-form-field style="width:100%">
                                        <mat-label>{{'tieu_de' | translate}}</mat-label>
                                        <mat-select [(ngModel)]="index" (ngModelChange)="chooseHeader($event)">
                                            <mat-option *ngFor="let collapse of listCollapse"
                                                [value]="collapse.value">{{collapse.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="staticdata.collapse && staticdata.collapse[index]" style="width:100%">
                                        <mat-label>{{'noi_dung_chu' | translate}}</mat-label>
                                        <textarea style="height:80px;background: #edf6fd;
                                            padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                                            border-top-right-radius:5px" matInput
                                            [ngModel]="staticdata.collapse[index]['header_' + functionService.selectedLanguageCode] | vhLanguage : 'header' : objectChoosing.component" 
                                            (ngModelChange)="staticdata.collapse[index]['header_' + functionService.selectedLanguageCode] = $event" 
                                            (blur)="handleChangeStaticdata()"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <!-- Font, Kích thước, Kiểu chữ, Canh lề -->
                            <app-text-format-config
                                [device]="device"
                                [objectChoosing]="objectChoosing"
                                [class]="class"
                                [config]="config"
                                [staticdata]="staticdata"
                                [textContentClass]="class['text-collapse__title']"
                                [textWrapperClass]="class['text-collapse__header']">
                            </app-text-format-config>
                            <div class="field-row">
                                <div class="config-font">
                                    <!-- Khoảng cách chữ -->
                                    <app-letter-spacing-config
                                        [objectChoosing]="objectChoosing"
                                        [device]="device"
                                        [class]="class"
                                        [classLetterSpacing]="class['text-collapse__title']"
                                        (updateClass)="updateClass()">
                                    </app-letter-spacing-config>
                                    <!-- Khoảng cách dòng -->
                                    <app-line-height-config
                                        [objectChoosing]="objectChoosing"
                                        [device]="device"
                                        [class]="class"
                                        [classLineHeight]="class['text-collapse__title']"
                                        (updateClass)="updateClass()">
                                    </app-line-height-config>
                                    <!-- Khoảng đệm -->
                                    <div>
                                        <div class="config-name mt-2">
                                            <p class="m-0" style="line-height:1.5">{{'khoang_dem' | translate}}</p>
                                            <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                                                [ngModel]="class['text-collapse__header']['padding'] | vhnumber"
                                                (nzBlur)="updateClass()"
                                                (ngModelChange)="class['text-collapse__header']['padding'] = $event +'px'">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [ngModel]="class['text-collapse__header']['padding'] | vhnumber"
                                                    (nzOnAfterChange)="updateClass();"
                                                    (ngModelChange)="class['text-collapse__header']['padding'] = $event +'px'">
                                                </nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                    <!-- Màu nền -->
                                    <div class="field-row mt-2">
                                        <div class="config-font"
                                            style="display:flex;align-items:center;justify-content: space-between;">
                                            <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
                                            <input class="input-color w-50"
                                                style="width:62px;height:26px;border-radius:5px;border:0;box-shadow:1px 1px 2px #aaa"
                                                [style.background]="class['text-collapse__header']['background-color']"
                                                [cpOKButton]="true" [(colorPicker)]="class['text-collapse__header']['background-color']"
                                                (colorPickerClose)="updateClass()" />
                                        </div>
                                    </div>
                                    <hr style="border-top: 1px solid rgb(223 223 223)" />
                                    <!-- Kiểu viền / Kích thước viền / Màu viền -->
                                    <app-borders-config 
                                        [elementChoosing]="objectChoosing"
                                        [device]="device" 
                                        [class]="class" 
                                        [borderClass]="class['text-collapse__header']"
                                        [id_object]="objectChoosing._id">
                                    </app-borders-config>
                                    <!-- Mở rộng -->
                                    <div class="mr-2 mb-4 mt-4 view-more" style="
                                        display: flex;
                                        align-items: center;
                                        justify-content: flex-end;
                                        gap: 7px;
                                        ">
                                        <p class="discover_text" (click)="openViewAll(styles_field[1])"
                                            style="cursor: pointer; text-align: left; margin: 0">
                                            {{'mo_rong' | translate}} &#8594;
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <!-- HIỆU ỨNG TIÊU ĐỀ -->
            <li nz-submenu nzTitle="{{'hieu_ung_tieu_de' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
                <app-choose-animations-config (openAnimationDetail)="openAnimationDetail($event)"
                    [elementChoosing]="objectChoosing" [effectFileUsing]="'text-collapse'"
                    [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config"
                    [staticdata]="staticdata" [cursorClass]="class['text-collapse__header']"
                    [effect_hover]="effect_hover" [customize]="customize">
                </app-choose-animations-config>
            </li>
            <!-- HIỆU ỨNG NỘI DUNG -->
            <li nz-submenu nzTitle="{{'hieu_ung_noi_dung' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
                <app-choose-animations-config (openAnimationDetailChild)="openAnimationDetailChild($event)"
                    [elementChoosing]="objectChoosing" [effectFileUsing]="'text-collapse'" [isParent]="false"
                    [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config"
                    [staticdata]="staticdata" [cursorClass]="class['text-collapse__body']"
                    [effect_hover]="effect_hover" [customize]="customize">
                </app-choose-animations-config>
            </li>
            <!-- NỘI DUNG CƠ BẢN -->
            <li nz-submenu nzTitle="{{'noi_dung_co_ban' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
                <div class="editor-field">
                    <div class="editor-field-body">
                        <div class="content-collapse">
                            <!-- Nội dung Collapse -->
                            <div class="field-row">
                                <div class="config-font">
                                    <mat-form-field style="width:100%">
                                        <mat-label>Collapse</mat-label>
                                        <mat-select [(ngModel)]="index" (ngModelChange)="chooseHeader($event)">
                                            <mat-option *ngFor="let collapse of listCollapseContent"
                                                [value]="collapse.value">{{collapse.name}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="staticdata.collapse && staticdata.collapse[index]" style="width:100%">
                                        <mat-label>{{'noi_dung_collapse' | translate}}</mat-label>
                                        <textarea
                                            style="height:80px;background: #edf6fd;
                                            padding:10px 6px;font-size:13px;border-top-left-radius:5px;
                                            border-top-right-radius:5px" matInput
                                            [ngModel]="staticdata.collapse[index]['content_' + functionService.selectedLanguageCode] | vhLanguage : 'content' : objectChoosing.component" 
                                            (ngModelChange)="staticdata.collapse[index]['content_' + functionService.selectedLanguageCode] = $event" 
                                            (blur)="handleChangeStaticdata()"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <!-- Font, Kích thước, Kiểu chữ, Canh lề -->
                            <app-text-format-config
                                [device]="device"
                                [objectChoosing]="objectChoosing"
                                [class]="class"
                                [config]="config"
                                [staticdata]="staticdata"
                                [textContentClass]="class['text-collapse__content']"
                                [textWrapperClass]="class['text-collapse__body']">
                            </app-text-format-config>
                            <div class="field-row">
                                <div class="config-font">
                                    <!-- Khoảng cách chữ -->
                                    <app-letter-spacing-config
                                        [objectChoosing]="objectChoosing"
                                        [device]="device"
                                        [class]="class"
                                        [classLetterSpacing]="class['text-collapse__content']"
                                        (updateClass)="updateClass()">
                                    </app-letter-spacing-config>
                                    <!-- Khoảng cách dòng -->
                                    <app-line-height-config
                                        [objectChoosing]="objectChoosing"
                                        [device]="device"
                                        [class]="class"
                                        [classLineHeight]="class['text-collapse__content']"
                                        (updateClass)="updateClass()">
                                    </app-line-height-config>
                                    <!-- Khoảng đệm -->
                                    <div>
                                        <div class="config-name mt-2">
                                            <p class="m-0" style="line-height:1.5">{{'khoang_dem' | translate}}</p>
                                            <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                                                [ngModel]="class['text-collapse__content']['padding'] | vhnumber"
                                                (nzBlur)="updateClass()"
                                                (ngModelChange)="class['text-collapse__content']['padding'] = $event +'px'">
                                            </nz-input-number>
                                        </div>
                                        <nz-row>
                                            <nz-col nzSpan="24">
                                                <nz-slider [nzMin]="0" [nzMax]="50"
                                                    [ngModel]="class['text-collapse__content']['padding'] | vhnumber"
                                                    (nzOnAfterChange)="updateClass();"
                                                    (ngModelChange)="class['text-collapse__content']['padding'] = $event +'px'">
                                                </nz-slider>
                                            </nz-col>
                                        </nz-row>
                                    </div>
                                    <!-- Màu nền -->
                                    <div class="field-row mt-2">
                                        <div class="config-font"
                                            style="display:flex;align-items:center;justify-content: space-between;">
                                            <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
                                            <input class="input-color w-50"
                                                style="width:62px;height:26px;border-radius:5px;border:0;box-shadow:1px 1px 2px #aaa"
                                                [style.background]="class['text-collapse__body']['background-color']"
                                                [cpOKButton]="true" [(colorPicker)]="class['text-collapse__body']['background-color']"
                                                (colorPickerClose)="updateClass()" />
                                        </div>
                                    </div>
                                    <!-- Kiểu viền / Kích thước viền / Màu viền -->
                                    <app-borders-config 
                                        [elementChoosing]="objectChoosing"
                                        [device]="device" 
                                        [class]="class" 
                                        [borderClass]="class['text-collapse__body']"
                                        [id_object]="objectChoosing._id">
                                    </app-borders-config>
                                    <!-- Mở rộng -->
                                    <div class="mr-2 mb-4 mt-4 view-more" style="
                                        display: flex;
                                        align-items: center;
                                        justify-content: flex-end;
                                        gap: 7px;
                                        ">
                                        <p class="discover_text" (click)="openViewAll(styles_field[2])"
                                            style="cursor: pointer; text-align: left; margin: 0">
                                            {{'mo_rong' | translate}} &#8594;
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <!-- BIỂU TƯỢNG -->
            <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
                <div style="padding: 5px 10px;">
                    <!-- Loại -->
                    <div>
                        <mat-form-field style="width:100%">
                            <mat-label>Loại</mat-label>
                            <mat-select [(ngModel)]="config['icon_name']" (ngModelChange)="updateConfig()">
                                <mat-option *ngFor="let collapse of iconType" [value]="collapse.value">
                                    {{collapse.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="config-name">
                        <mat-form-field style="width:60%">
                            <mat-label>Vị trí</mat-label>
                            <mat-select [(ngModel)]="class['text-collapse__header']['flex-direction']"
                                (ngModelChange)="updateClass()">
                                <mat-option *ngFor="let collapse of iconPosition"
                                    [value]="collapse.value">{{collapse.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field style="width:40%">
                            <!-- Kích thước biểu tượng -->
                            <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                            <input matInput type="number" [min]="1" [max]="100"
                                [ngModel]="class['text-collapse__icon']['font-size'] | vhnumber"
                                (ngModelChange)="class['text-collapse__icon']['font-size'] = $event +'px';"
                                (blur)="updateClass()">
                        </mat-form-field>
                    </div>
                    <!-- Màu biểu tượng -->
                    <div class="field-row mt-2">
                        <div class="config-name">
                            <p class="m-0 title" style="width: 50%;">{{'mau_bieu_tuong' | translate}}</p>
                            <div style="width: 50%;">
                                <input class="input-color "
                                    style="height:26px;border-radius:5px;border:0;box-shadow:1px 1px 2px #aaa;cursor: pointer;width: 100%;"
                                    [style.background]="class['text-collapse__icon-wrapper']['color']"
                                    [cpOKButton]="true" [(colorPicker)]="class['text-collapse__icon-wrapper']['color']"
                                    (colorPickerClose)="updateClass()" />
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </ng-container>

    <!-- CẤU HÌNH CHI TIẾT -->
    <div class="view-more" *ngIf="isViewAll">
        <!-- Cấu hình chi tiết hiệu ứng -->
        <div class="editor_effect-hover" *ngIf="currentViewAll.index == 1 || currentViewAll.index == 5">
            <app-animations-config [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize" [isParent]="currentViewAll.index == 1"></app-animations-config>
        </div>
        <!-- Cấu hình chi tiết viền Tiêu đề -->
        <div class="view_more-border" *ngIf="currentViewAll.index == 2">
            <!-- Bo tròn -->
            <app-borders-radius-config 
                [elementChoosing]="objectChoosing"
                [device]="device" 
                [class]="class" 
                [borderRadiusClass]="class['text-collapse__header']"
                [id_object]="objectChoosing._id">
            </app-borders-radius-config>
        </div>
        <!-- Cấu hình chi tiết viền Nội dung -->
        <div class="view_more-border" *ngIf="currentViewAll.index == 3">
            <!-- Bo tròn -->
            <app-borders-radius-config 
                [elementChoosing]="objectChoosing"
                [device]="device" 
                [class]="class" 
                [borderRadiusClass]="class['text-collapse__body']"
                [id_object]="objectChoosing._id">
            </app-borders-radius-config>
        </div>
    </div>
</div>